import React from 'react'
import CompareAIContext from '../../../contexts/CompareAIContext'
import StatusContext from '../../../contexts/StatusContext';

import { Row, Col } from 'react-bootstrap';

import { useState, useEffect } from "react";
import './compareai.css'
import { NavBarCompareAI } from '../navbarcompareai/NavBarCompareAI'
import { ProgressIcon } from '../customicons/ProgressIcon';
import { AlertDialog } from '../alertdialog/AlertDialog'

import Stack from '@mui/material/Stack'
import {PushButton} from '../pushbutton/PushButton'
import {AvailableCredits} from '../availablecredits/AvailableCredits'
import {LoginDialog} from '../logindialog/LoginDialog'

import { PromptWithIcon } from '../promptwithicon/PromptWithIcon';

import { ResponseDisplay } from "../responsedisplay/ResponseDisplay"
import { DialogAIProgress } from '../compareai/DialogAIProgress';
import AIButton from '../aibutton/AIButton';
import { WaitonResponse } from '../waitonresponse/WaitonResponse';

import { DialogSelectModels } from '../aibutton/DialogSelectModels';

export const CompareAI = () => {
  const [dialogText, setDialogText] = useState('')

  let {
    promptsandresponsesPaneOne, 
    promptsandresponsesPaneTwo, 
   
    setPromptsAndResponsesPaneOne,
    setPromptsAndResponsesPaneTwo,
  
    onSubmitChat,
    status,
    promptareaRef,
    chatPrompt, 
    setChatPrompt,
    confirmDeletePaneOne,
    confirmDeletePaneTwo,
   
    changeConfirmDeletePaneOne,
    changeConfirmDeletePaneTwo,
 
    onResubmitChat,

    onDeletePromptPaneOne,
    onDeletePromptPaneTwo,
   
    activePane,
    saveActivePane,

    getCompareAIProvider,
    getCompareAIName,
   

  } = React.useContext(CompareAIContext);

  let {
    isMobile, 
    scrollRef,
    isLoading,
    changeLanguage,
    openDialog,
    openDialogResponse,
    openDialogBox,
    closeDialogBox,
    closeDialogBoxResponse,
    onCopy,
    onClickAIButton,
  
  } = React.useContext(StatusContext);

 

  const onClearData = () => {
  
    setDialogText(changeLanguage('dialog', 'cleardata'))
    openDialogBox()
  }
  
  const alertYes = () => {
    console.log("AlertYes")

   

    if (activePane === 1)
      setPromptsAndResponsesPaneOne([])
    else if (activePane === 2)
      setPromptsAndResponsesPaneTwo([])
 

    closeDialogBox()
}

const alertCancel = () => {
  console.log("AlertCancel")
  closeDialogBox()
}

const alertYesResponses = () => {
  console.log("AlertYesResponses")
 
  closeDialogBoxResponse()
}

const alertCancelResponse = () => {
  console.log("AlertCancel")
  closeDialogBoxResponse()
}

  useEffect(() => {
   
  }, [])

 

  const handleOnClickPaneOne = () => {
    console.log("handleOnClick - PaneOne")
    saveActivePane(1)
  }

  const handleOnClickPaneTwo = () => {
    console.log("handleOnClick - PaneTwo")
    saveActivePane(2)
  }

  return (

    <div className="homeContainer">

      <>
        {
        
            <div >
              <NavBarCompareAI title={changeLanguage('compareai', 'navbartitle')} />

              <>

              {

              (!isMobile()) ?
                <Row >
                
                  <Col onClick={handleOnClickPaneOne}>
                 
                    <div className={activePane === 1 ? "compareaiPromptAreaFocus" : "compareaiPromptArea"} ref={promptareaRef}>
                     
                       <div className="compareai-response-markdown" ref={scrollRef}>
                                 
                                  {
                                    Array.isArray(promptsandresponsesPaneOne) &&
                                    promptsandresponsesPaneOne.map((item) => (
                                      <ResponseDisplay key={item.id} displayprompt={item} displayicons={confirmDeletePaneOne[promptsandresponsesPaneOne.indexOf(item)].state}
                                        changeConfirmDelete={changeConfirmDeletePaneOne} onDeletePrompt={onDeletePromptPaneOne} onResubmitQuestion={onResubmitChat} onCopy={onCopy}
                                        width = {1}/>
                                    ))
                                  }
                                  {
                                      (activePane === 1) &&
                                          <WaitonResponse />
                                  }
                                     
                        </div>
                       
                    </div>

                    <div  className="mainButtons">
                        <Stack direction="row" spacing={2}>
                            <AIButton pane = {1} provider = {getCompareAIProvider(1)} model = {getCompareAIName(1)} onClick = {()=>{onClickAIButton(1)}}/>
                            <PushButton onClick={()=>{onClearData()}} label =  {changeLanguage('templates','clearall')}/>
                         </Stack>
                    </div>
                  
                  </Col>

                  <Col onClick={handleOnClickPaneTwo}>
                 
                 
                    <div  className={activePane === 2 ? "compareaiPromptAreaFocus" : "compareaiPromptArea"} ref={promptareaRef}>
                     
                      <div className="compareai-response-markdown" ref={scrollRef}>
                       
                                  {
                                    Array.isArray(promptsandresponsesPaneTwo) &&
                                    promptsandresponsesPaneTwo.map((item) => (
                                      <ResponseDisplay key={item.id} displayprompt={item} displayicons={confirmDeletePaneTwo[promptsandresponsesPaneTwo.indexOf(item)].state}
                                        changeConfirmDelete={changeConfirmDeletePaneTwo} onDeletePrompt={onDeletePromptPaneTwo} onResubmitQuestion={onResubmitChat} onCopy={onCopy}
                                        width = {2} />
                                    ))
                                  } 

                                  {
                                    (activePane === 2) &&
                                      <WaitonResponse />      
                                  }
                        </div>

                    </div>
                   
                    <div  className="mainButtons">
                        <Stack direction="row" spacing={2}>
                            <AIButton pane = {2}  provider={getCompareAIProvider(2)} model={getCompareAIName(2)} onClick = {()=>{onClickAIButton(2)}}/>
                            <PushButton onClick={()=>{onClearData()}} label =  {changeLanguage('templates','clearall')}/>     
                        </Stack>
                    </div>
                  </Col>
                </Row>

                :

                <Row >
                
                  <div onClick={handleOnClickPaneOne}>
                    <div className={activePane === 1 ? "compareaiPromptAreaFocus" : "compareaiPromptArea"} ref={promptareaRef}>
                    
                     
                       <div className="compareai-response-markdown" ref={scrollRef}>
                            
                        {
                          Array.isArray(promptsandresponsesPaneOne) &&
                            promptsandresponsesPaneOne.map((item) => (
                              <ResponseDisplay key={item.id} displayprompt={item} displayicons={confirmDeletePaneOne[promptsandresponsesPaneOne.indexOf(item)].state}
                                changeConfirmDelete={changeConfirmDeletePaneOne} onDeletePrompt={onDeletePromptPaneOne} onResubmitQuestion={onResubmitChat} onCopy={onCopy}/>
                          ))
                        }
                                   
                        {
                          (activePane === 1) &&
                            <WaitonResponse />   
                        }
                                           
                        </div>
                       
                    </div>

                    <div  className="mainButtons">
                        <Stack direction="row" spacing={2}>
                            <AIButton pane = {1} provider = {getCompareAIProvider(1)} model = {getCompareAIName(1)} onClick = {()=>{onClickAIButton(1)}}/>
                            <PushButton onClick={()=>{onClearData()}} label =  {changeLanguage('templates','clearall')}/>
                         </Stack>
                    </div>
                  </div>

                  <div onClick={handleOnClickPaneTwo}>
                 
                    <div className={activePane === 2 ? "compareaiPromptAreaFocus" : "compareaiPromptArea"} ref={promptareaRef}>
                    
                     
                      <div className="compareai-response-markdown" ref={scrollRef}>
                             
                        {
                          Array.isArray(promptsandresponsesPaneTwo) &&
                            promptsandresponsesPaneTwo.map((item) => (
                            <ResponseDisplay key={item.id} displayprompt={item} displayicons={confirmDeletePaneTwo[promptsandresponsesPaneTwo.indexOf(item)].state}
                              changeConfirmDelete={changeConfirmDeletePaneTwo} onDeletePrompt={onDeletePromptPaneTwo} onResubmitQuestion={onResubmitChat} onCopy={onCopy}/>
                            ))
                        } 
   
                        {
                          (activePane === 2) &&
                            <WaitonResponse />     
                        }
                                  
                        </div>
                       
                    </div>

                    <div  className="mainButtons">
                        <Stack direction="row" spacing={2}>
                            <AIButton pane = {2} provider = {getCompareAIProvider(2)} model = {getCompareAIName(2)} onClick = {()=>{onClickAIButton(2)}}/>
                            <PushButton onClick={()=>{onClearData()}} label =  {changeLanguage('templates','clearall')}/>     
                        </Stack>
                    </div>
                  </div>

                </Row>
                }
                </>

                <div>
                  <PromptWithIcon prompt = {chatPrompt} setPrompt={setChatPrompt} onSubmit={onSubmitChat} placeholdertext={changeLanguage('assistant','promptplaceholder')}/>
                
                </div>
                {
                    (status) && <label className='statusLabel'>{status}</label>
                  }

                <AvailableCredits />
              
              <label style={{ width: isMobile() ? '100%' : '50%' }}>{changeLanguage("comprehensiveresponses", "note_1")}</label>
              <LoginDialog />

            </div>
        }
      </>
   
      <ProgressIcon isLoading={isLoading} />
      <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog = {openDialog} closeDialog = {closeDialogBox} prompt={dialogText}/>
      <AlertDialog alertYes={alertYesResponses} alertCancel={alertCancelResponse} openDialog = {openDialogResponse} closeDialog = {closeDialogBoxResponse} prompt={changeLanguage('dialog', 'clearresponse')}/>
      <DialogAIProgress />
       <DialogSelectModels />
    </div>
  )
}

export default CompareAI